<template >
  <div class="results">
    <div class="switch-row">
      <el-radio-group v-model="resultTab">
        <el-radio-button ghost v-for="item in radios" :key="item.value" :label="item.value">
          {{ `${item.label}(${item.sum})` }}
        </el-radio-button>
      </el-radio-group>

      <el-button type="text" @click="removeSelected">清空全部</el-button>
    </div>

    <div class="result-row">
      <div v-for="item in results" :key="item.id" class="result-item">
        <span>{{ item.name }}</span>
        <span class="el-icon-error remove" @click="removeItem(item)"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number // 当前选中的tab值
    },
    results: {
      type: Array, // 已选结果
      required: true
    },
    radios: {
      type: Array, // radio选项
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    resultTab: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    removeSelected() {
      this.$emit('remove-all')
    },
    removeItem(item) {
      this.$emit('remove-item', item)
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin block {
  width: 420px;
  height: 240px;
  background: #f6f6f6;
  border-radius: 4px;
}

.results {
  @include block;
  margin-left: 10px;
  padding: 10px 0;
  .switch-row {
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
  }
  .result-row {
    line-height: 18px;
    height: 185px;
    background: #f6f6f6;
    padding-left: 10px;
    overflow: auto;

    .result-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .remove {
        cursor: pointer;
        margin-right: 10px;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
